module.exports = __webpack_public_path__ + "img/Carrousels STARTO_rdv_slide_4.03ad7246.png";